
































import Vue from 'vue'
import VueSortable from "../../../components/sortable";
import Checkbox from '../../../components/Checkbox.vue'

export default Vue.extend({
    props: ['settings'],
    components: {
        Checkbox
    },
    data() {
    	return {
    	}
    },
    mounted() {
        if (this.settings.form_topics.length == 0) {
            this.settings.form_topics.push({active: 1, topic: ''})
        }
    },
    methods: {
        deleteItem(index: number) {
            if (index > -1) {
                this.settings.form_topics.splice(index, 1)
            }
        },
        addItem() {
            if (!Array.isArray(this.settings.form_topics)) {
                this.settings.form_topics= []
            }
            this.settings.form_topics.push({active: 1, topic: ''})
        },
        getSortParams() {
            let self = this
            let params = {
                animation: 150,
                handle: '.sort-handle',
                onEnd(event: any) {
                    self.sortUpdate(event)
                } 
            }
            return params 
        },
        sortUpdate(event: any) {
            let clonedItems = this.settings.form_topics.filter((item: any) => {
                return item;
            });
            clonedItems.splice(event.newIndex, 0, clonedItems.splice(event.oldIndex, 1)[0]);
            this.settings.form_topics = [];
            this.$nextTick(() => {
                this.settings.form_topics = clonedItems;
            });
        }
    },
    directives: {
        sortable: VueSortable
    }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/settings/components/form/FormTopic.vue